import { logger } from "@/utils/logger";

import { axiosInstance } from "./axiosInstance";

export type UserTimezone = "PACIFIC" | "MOUNTAIN" | "CENTRAL" | "EASTERN";
export type UserDateFormat =
  | "MM_DD_YYYY"
  | "DD_MM_YYYY"
  | "YYYY_MM_DD_SLASH"
  | "YYYY_MM_DD_DASH"
  | "D_MMM_YYYY";
export type UserTimeFormat = "H12" | "H12_SECONDS" | "H24" | "H24_SECONDS";

export interface UserLocalePreferences {
  timezone: UserTimezone;
  dateFormat: UserDateFormat;
  timeFormat: UserTimeFormat;
}

export const getUserLocalePreferences = async (): Promise<UserLocalePreferences | null> => {
  try {
    const response = await axiosInstance.get("/api/v1/user-locale-preferences");
    return response.data;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      return null;
    }

    logger.error("Error fetching user locale preferences", {
      error,
      context: "getUserLocalePreferences",
      endpoint: "/api/v1/user-locale-preferences",
    });
    throw error;
  }
};

export const upsertUserLocalePreferences = async (
  payload: UserLocalePreferences
): Promise<UserLocalePreferences> => {
  try {
    const response = await axiosInstance.post("/api/v1/user-locale-preferences", payload);
    return response.data;
  } catch (error) {
    logger.error("Error upserting user locale preferences", {
      error,
      context: "upsertUserLocalePreferences",
      endpoint: "/api/v1/user-locale-preferences",
    });
    throw error;
  }
};
